// extracted by mini-css-extract-plugin
export var category = "_ju-9";
export var categoryHeader = "_ju-e";
export var container = "_ju-0";
export var group = "_ju-a";
export var groupItems = "_ju-f";
export var groupSeparator = "_ju-j";
export var loading = "_ju-1";
export var noResults = "_ju-3";
export var placeholder = "_ju-2";
export var resultContent = "_ju-5";
export var resultIcon = "_ju-c";
export var resultItem = "_ju-g";
export var resultMeta = "_ju-8";
export var resultSubtitle = "_ju-7";
export var resultSuffix = "_ju-i";
export var resultTitle = "_ju-6";
export var resultsList = "_ju-4";
export var searchGroup = "_ju-d";
export var selected = "_ju-h";
export var subgroup = "_ju-b";